export var AUTH_LOGIN_START = 'auth/loginStart';
export var AUTH_LOGIN_DONE = 'auth/loginDone';
export var AUTH_LOGIN_FAIL = 'auth/loginFail';
export var AUTH_LOGOUT_START = 'auth/logoutStart';
export var AUTH_LOGOUT_DONE = 'auth/logoutDone';
export var AUTH_LOGOUT_FAIL = 'auth/logoutFail';